import React, { FC } from 'react';

import ReadingsPage from "@/components/readings/ReadingsPage";
import { Medium } from "@/constants/mediums";

const ElectricityReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.electricity} />;
};

export default ElectricityReadingsPage;
